const dom = require('../utils/DOM');
const Router = require('../helpers/Router');

function NextArticle() {
	// eslint-disable-next-line
	if ((dom.$body.hasClass('single-article') || dom.$body.hasClass('single-biblio')) && wpData) {
		this.wpData = wpData; // eslint-disable-line
		this.init(); // eslint-disable-line
	}
}

NextArticle.prototype = {
	init: function() {
		const isArticle = dom.$body.hasClass('single-article');
		this.nextUrl = isArticle ? this.wpData.navi.nextArtUrl : this.wpData.navi.nextABiblioUrl;
		this.nextID = this.wpData.navi.currID;
		this.updateNext();
	},
	clearArticle: function() {
		if (document.head.createShadowRoot && document.head.attachShadow) {
			this.shadowRoot = null;
			this.shadowRoot = article_container.attachShadow({ mode: 'open' }); // eslint-disable-line
			// shadowRoot.innerHTML = article_template.innerHTML; // eslint-disable-line
			this.shadowRoot.appendChild(article_template.content); // eslint-disable-line
		} else {
			const $article = dom.$body.find('.article-body');
			$('#article_container').html($('#article_template').html());
			if ($article.length) {
				const $legacy = $article.find('style, meta, link');
				$legacy.remove();
			}
		}
	},
	updateNext: function() {
		this.clearArticle();
		this.$title = $('title');
		this.$content = $('#primary');
		this.$article = this.$content.find('.article');

		this.$articleNext = this.$content.find('.articleNext');

		this.$articleNoteLinks = this.$article.find('[name]');
		// this.$articleNoteLinks = this.$article.find('.text-link');
		this.$noteLinks = this.$content.find('.note-link');
		this.$articleType = this.$content.find('.article-type-js');
		this.$nextMark = this.$articleNext.find('.next-mark');
		if (this.shadowRoot) {
			this.$articleNoteLinks = this.shadowRoot.querySelectorAll('a[name]');
			for (let i = 0; i < this.$articleNoteLinks.length; i++) {
				const $link = this.$articleNoteLinks[i];
				$link.addEventListener('click', e => {
					e.preventDefault();
					const note = $link.name;
					const $note = this.shadowRoot.querySelector(`[href='#${note}']`);
					$note.classList.add('active-note');
					dom.$window.scrollTop($note.offsetTop - Math.round(dom.$window.height() / 3));
					setTimeout(() => {
						$note.classList.remove('active-note');
					}, 1000);
				});
			}
		} else {
			this.initNote();
		}

		this.$articleNext.on('click', () => {
			this.loadNext();
		});
	},
	initNote: function() {
		this.$articleNoteLinks.on('click', e => {
			e.preventDefault();
			console.log($(this));
			const note = $(e.currentTarget).attr('name');
			// .replace('text', '');
			const $note = $(`[href='#${note}']`);
			$note.addClass('active-note');
			dom.$window.scrollTop($note.offset().top - Math.round(dom.$window.height() / 3));
			setTimeout(() => {
				$note.removeClass('active-note');
			}, 1000);
		});

		// this.$noteLinks.on('click', e => {
		// 	e.preventDefault();
		// 	const target = e.currentTarget.hash;
		// 	const $target = $(target);
		// 	dom.$window.scrollTop($target.offset().top - Math.round(dom.$window.height() / 3));
		// });
	},
	loadNext: function() {
		const self = this;
		$.ajax({
			url: this.nextUrl + this.nextID,
			success: function(response, status, jqXHR) {
				if (jqXHR.status == 200) {
					self.goToNext(response);
					self.updateNext();
				} else {
					console.log(jqXHR);
					self.hideNext();
				}
			},
			error: function(response) {
				console.log(response);
				// self.hideNext();
			},
		});
	},
	hideNext: function() {
		this.$articleNext.hide();
	},
	goToNext: function(data) {
		this.nextID = data.id;
		// this.$article.addClass('opacity-change');
		this.$content.addClass('opacity-change');

		this.$articleNext.addClass('move-up-block');
		const self = this;
		const completeHandler = () => {
			self.$articleNext.css('transition', 'background 0.3s ease-in-out');
			// self.$article.html(data.body_html || '');
			self.$content.html(data.body_html || '');
			// self.$article.removeClass('opacity-change');
			self.$content.removeClass('opacity-change');
			self.$articleNext.css({ opacity: '0' });
			self.$articleNext.removeClass('move-up-block');
			setTimeout(function() {
				self.$articleNext.remove();
				self.$content.append(data.next_post_html);
				const $style = self.$content.find('style');
				$style.remove();
				self.updateNext();
				// Sharing.init();
				self.$title.html(data.title);
				Router.set(data.url);
			}, 100);
		};
		TweenMax.to(window, 0.5, { scrollTo: 0, onComplete: completeHandler });
	},
};

module.exports = new NextArticle();
